import { type FC, useState } from "react";

import { CourseMenu } from "components/menus/CourseMenu";
import { TermMenu } from "components/menus/TermMenu";
import { t } from "i18n/i18n";
import { SquareButton } from "mds/components/buttons/SquareButton";

type CopyMoveSectionModalProps = {
  mode: "copy" | "move";
  defaultCourseId: string | null;
  defaultTermId: string | null;
  onSubmit: (courseId: string, termId: string) => void;
  onClose: () => void;
};

export const CopyMoveSectionModal: FC<CopyMoveSectionModalProps> = ({
  mode,
  defaultCourseId,
  defaultTermId,
  onSubmit,
  onClose,
}) => {
  const [selectedCourseId, setSelectedCourseId] = useState(defaultCourseId || "");
  const [selectedTermId, setSelectedTermId] = useState(defaultTermId || "");
  const isValid = Boolean(selectedCourseId && selectedTermId);

  const handleSubmit = () => {
    if (!isValid) return;
    onSubmit(selectedCourseId, selectedTermId);
  };

  return (
    <div className="mt-2">
      <div className="flex gap-4">
        <div className="flex min-w-0 flex-1 flex-col gap-2">
          <label className="flex flex-col gap-1">
            <span className="sr-only">{t("home.terms.select_term_label")}</span>

            <TermMenu
              className="w-full"
              defaultToAll={false}
              selectedTermId={selectedTermId}
              size="s"
              onTermChange={setSelectedTermId}
            />
          </label>
        </div>

        <div className="flex min-w-0 flex-1 flex-col gap-2">
          <label className="flex flex-col gap-1">
            <span className="sr-only">{t("home.courses.select_course_label")}</span>

            <CourseMenu
              defaultToAll={false}
              selectedCourseId={selectedCourseId}
              size="s"
              adminAccessibleOnly
              onCourseChange={setSelectedCourseId}
            />
          </label>
        </div>
      </div>

      <div className="mt-8 flex w-full justify-end gap-2">
        <SquareButton kind="tertiary" size="m" title={t("common.cancel")} onClick={onClose}>
          {t("common.cancel")}
        </SquareButton>

        <SquareButton disabled={!isValid} kind="accent" size="m" onClick={handleSubmit}>
          {mode === "copy"
            ? t("sidebar_options_menu.copy_section_button")
            : t("sidebar_options_menu.move_section_button")}
        </SquareButton>
      </div>
    </div>
  );
};
